import { useState } from 'react';
import styled from 'styled-components';
import { mapi } from './api';
import { Button, Field, Hint, Panel, Warn } from '../ui/primitives';

const Keskita = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;

interface Props {
  needSetup: boolean;
  onDone: () => void;
}

export function MasterLogin({ needSetup, onDone }: Props) {
  const [nimi, setNimi] = useState('');
  const [salasana, setSalasana] = useState('');
  const [virhe, setVirhe] = useState<string | null>(null);
  const [kesken, setKesken] = useState(false);

  const laheta = async () => {
    setKesken(true);
    setVirhe(null);
    try {
      await mapi(needSetup ? '/api/master/setup' : '/api/master/login', 'POST',
        { name: nimi.trim(), password: salasana });
      onDone();
    } catch (err) {
      setVirhe(err instanceof Error ? err.message : String(err));
    }
    setKesken(false);
  };

  return (
    <Keskita>
      <Panel $max="380px" style={{ width: '100%' }}>
        <h2 style={{ marginTop: 0, marginBottom: 2 }}>ISOFAN</h2>
        <Hint style={{ marginTop: 0 }}>
          {needSetup
            ? 'Master. Ensimmäinen käyttökerta — luo tunnus. Tällä hallitaan ohjelma-asiakkaiden laskutusta ja ominaisuuksia.'
            : 'Master. Kirjaudu sisään. Tunnus on eri kuin asiakassovelluksessa.'}
        </Hint>
        <form onSubmit={e => { e.preventDefault(); void laheta(); }}>
          <Field>
            <label htmlFor="mNimi">Käyttäjänimi</label>
            <input id="mNimi" value={nimi} onChange={e => setNimi(e.target.value)} autoFocus />
          </Field>
          <Field>
            <label htmlFor="mPw">Salasana{needSetup ? ' (vähintään 8 merkkiä)' : ''}</label>
            <input
              id="mPw" type="password" autoComplete={needSetup ? 'new-password' : 'current-password'}
              value={salasana} onChange={e => setSalasana(e.target.value)}
            />
          </Field>
          {virhe && <Warn>{virhe}</Warn>}
          <Button type="submit" $variant="primary" disabled={kesken} style={{ width: '100%', marginTop: 8 }}>
            {needSetup ? 'Luo tunnus ja kirjaudu' : 'Kirjaudu'}
          </Button>
        </form>
      </Panel>
    </Keskita>
  );
}
